import { onDocumentLoaded } from "../utils/on-document-loaded.js";
import { mosaicSlider } from "../lib/mosaic-slider.js";

onDocumentLoaded(() => {
    mosaicSlider();
});